import React from "react";
import { partnerWorkflowStatus } from "./medicalPartnerListTableHelpers";
import { PARTNER_WORKFLOW_OPTIONS } from "./medicalPartnerAdminConstants";

const MedicalPartnerListStatusSelect = ({ rowId, item, disabled, onStatusChange }) => {
  const value = partnerWorkflowStatus(item);
  return (
    <select
      id={`partner-list-status-${rowId}`}
      className="form-control form-control-sm medical-partner-list__status-select"
      value={value}
      disabled={disabled}
      aria-label="Partner workflow — Live means verified; draft and pending still allow TC and MT setup in admin"
      onChange={(e) => {
        e.stopPropagation();
        onStatusChange(item, e.target.value);
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {PARTNER_WORKFLOW_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default MedicalPartnerListStatusSelect;
